var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiple-actions-menu',{attrs:{"options":_vm.actionsOptions},on:{"onAction":_vm.onAction,"click":function($event){$event.stopPropagation();}}})}
var staticRenderFns = []

export { render, staticRenderFns }